/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import axios from 'axios';
import { Graphql } from '@common/graphql';
import { vappContainer } from '@/application';
import { apiConfig } from '@/config/apiConfig';
import { AppNavigatorService } from '@/AppNavigator/services';
import { ApplicationFormPageService } from '../index';
import { SAVE_APPLICATION } from '@pages/ApplicationForm/api/graphql';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { toast } from 'react-hot-toast';
import { workPermitConfig } from '../../config/workPermit.config';
import humanizeString from 'humanize-string';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

const getSrv = () => {
  return vappContainer.get<ApplicationFormPageService>(
    ApplicationFormPageService.displayName
  );
};

export interface IcreateroerenewworkPermitDraftMethods
  extends IPluginMethodMap {
  createroerenewworkPermitDraft(args: any): Promise<any>;
}

export interface createroerenewworkPermitDraftProps {}

export class createroerenewworkPermitDraftService implements IAgentPlugin {
  readonly methods: IcreateroerenewworkPermitDraftMethods;

  constructor() {
    this.methods = {
      createroerenewworkPermitDraft:
        this.createroerenewworkPermitDraft.bind(this),
    };
  }

  private async createroerenewworkPermitDraft(args: any) {
    const srv = getSrv();

    console.log(`workPermitApp service input data`, args);
    const storageService = StorageModule.getInstance();
    const _localData = storageService.get('userProfile', 'local');
    const _sessionData = storageService.get('userProfile', 'session');
    const userData = _sessionData ?? _localData;
    const storageSrv = StorageModule.getInstance();
    const { implicitSave } = args;
    let _draftId = storageSrv.get('DRAFT_APP_ID', 'session');
    _draftId = _draftId ? { draftId: _draftId } : {};
    const whoAmI =
      userData?.userRoles && Array.isArray(userData?.userRoles)
        ? userData?.userRoles[0]?.name
        : undefined;
    console.log(`workPermitApp service whoAmI`, whoAmI);
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      const token = loginSrv()?.getToken();
      console.log(`workPermitApp service token`, token);
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      if (client) {
        if (args && Object.keys(args)?.length > 1) {
          const _variables = this._getVariables(args, userData?.email, whoAmI);
          console.log(`workPermitApp service _variables`, _variables);
          console.log(`roe***--->jramworkPermitApp service client`, _variables);
          const res = await client.mutation(SAVE_APPLICATION, {
            ..._variables,
          });
          if (res?.data?.saveApplication) {
            console.log(`data:: `, res?.data);
            storageSrv.set(
              'DRAFT_APP_ID',
              res?.data?.saveApplication?.applicationNo,
              'session'
            );
            if (res?.data?.saveApplication?.applicant) {
              storageSrv.set(
                'LAST_DRAFT_APP',
                res?.data?.saveApplication?.applicant,
                'session'
              );
              storageSrv.set(
                'LAST_DRAFT_APP_ID',
                res?.data?.saveApplication?.applicationNo,
                'session'
              );
            }
            if (!implicitSave) toast.success('Application saved successfully');
            return res?.data?.saveApplication;
          } else {
            console.log('roe***--->jramworkPermitA--->failed');
            if (!implicitSave) toast.error('Failed to save application');
          }
        } else {
          if (!implicitSave)
            toast.error('Please fill the form to save the application');
        }
      }
    } catch (err: any) {
      console.log('error in activate User', err?.message);
      toast.error('Failed to save application');
      // throw err;
    }
  }

  private _getVariables = (data: any, createdBy: string, whoAmI: string) => {
    console.log('var data123', data);
    const _documents = this.getDocuments(data, data?.type);
    const storageSrv = StorageModule.getInstance();
    let _draftId = storageSrv.get('DRAFT_APP_ID', 'session');
    _draftId = _draftId ? { applicationNo: _draftId } : {};
    console.log(`_draftId ::::::`, _draftId);
    let _data: any = {};
    const applicant = data?.applicant ? { applicant: data?.applicant } : {};
    const occupation = data?.occupation;
    // if (data?.fillApplicantInfo) {
    _data = {
      input: {
        ..._draftId,
        // updateProfile: false,
        // status: 'EMPLOYER_DRAFT',
        //applicant: '003',
        ...applicant,
        type: data?.type,
        submit: data?.submit ?? false,
        // educationInfo: this.getEducationInfo(data),
        // employmentInfo: this.getEmploymentInfo(data),
        applicantInfo: {
          // nameChangeDocType: data?.isNameSupport ?? undefined,
          // maidenName: data?.maidenName || undefined,
          countryOfBirth: data?.countryOfBirth || undefined,
          // passportIssuanceDate: data?.passportIssuanceDate || undefined,
          // otherNationality: data?.otherNationality || undefined,

          firstName: data?.firstName,
          lastName: data?.lastName,
          middleName: data?.middleInitial,
          nationality: data?.nationality,
          // occupation: occupation,
          address: {
            addressLine1: data?.streetAddress1 ?? undefined,
            addressLine2: data?.streetAddress2 ?? undefined,
            // addressLine3: data?.street ?? undefined,
            city: data?.city ?? undefined,
            // country: data?.country ?? undefined,
            // parish: data?.parish ?? undefined,
            // state: null,
            // zipcode: data?.postalCode ?? undefined,
          },
          intendedAddress: {
            addressLine1: data?.intendedStreetAddress1 ?? undefined,
            addressLine2: data?.intendedStreetAddress2 ?? undefined,
          },
          placeOfBirth: data?.placeOfBirth ?? undefined,
          trn: data?.trn ?? null,
          // countryConvicted: data?.countryConvicted ?? undefined,
          // criminalOffence: data?.criminalOffence === 'yes' ? true : false,
          dateOfBirth: data?.dateOfBirth ?? undefined,
          email: data?.userEmail ?? undefined,
          gender: data?.gender,
          primaryContactNo: data?.telephoneContact ?? undefined,
          maritalStatus: data?.maritalStatus ?? undefined,
          workedInJamaica: data?.workedInJamaica === 'yes' ? true : false,
          skills: data?.occupationalSkill ?? undefined,
          passportNumber: data?.passport ?? undefined,
          passportExpiry: data?.passportExpiry ?? undefined,
          passportType: data?.typeOfPassport ?? undefined,
          highestQualification: data?.qualificationName ?? undefined,
        },
        documents: _documents,
        employerInfo: {
          noOfYearsWithCompany: data?.noOfYearsWithCompany ?? undefined,
        },
        jobInfo: {
          JobTitle: data?.jobTitle ?? undefined,

          // necessaryQualification: data?.qualificationName ?? undefined,
        },
      },
    };
    // } else {
    let _adata = {
      input: {
        ..._draftId,
        updateProfile: false,
        // status:
        //   whoAmI === 'prospective_employee'
        //     ? 'APPLICANT_DRAFT'
        //     : 'EMPLOYER_DRAFT',
        //applicant: '003',
        ...applicant,
        type: data?.type,

        documents: _documents,

        employerInfo: {
          address: {
            addressLine1: data?.businessAddress1 ?? undefined,
            addressLine2: data?.businessAddress2 ?? undefined,
            addressLine3: data?.businessStreet ?? undefined,
            city: data?.businessCity ?? undefined,
            country: data?.businessCountry ?? undefined,
            parish: data?.businessParish ?? undefined,
            state: undefined,
            zipcode: data?.businessPostalCode ?? undefined,
          },
          country: undefined,
          dateOfRegistration: data?.dateOfReg ?? undefined,
          declaration: {
            selected: undefined,
            value: undefined,
          },
          description: undefined,
          email: data?.email ?? undefined,
          fax: data?.faxNumber ?? undefined,
          incorporationDate: undefined,
          isSubsidiary: undefined,
          logo: undefined,
          name: data?.businessName ?? undefined,
          natureOfBusiness: data?.natureOfBusiness ?? undefined,
          operatingAddress: {
            addressLine1:
              data?.isMailingAddressSame === 'yes'
                ? data?.businessAddress1
                : data?.mailingAddress1,
            addressLine2:
              data?.isMailingAddressSame === 'yes'
                ? data?.businessAddress2
                : data?.mailingAddress2,
            addressLine3:
              data?.isMailingAddressSame === 'yes'
                ? data?.businessStreet
                : data?.mailingStreet,
            city:
              data?.isMailingAddressSame === 'yes'
                ? data?.businessCity
                : data?.mailingCity,
            country: data?.businessCountry ?? undefined,
            parish:
              data?.isMailingAddressSame === 'yes'
                ? data?.businessParish
                : data?.mailingParish,
            state: undefined,
            zipcode:
              data?.isMailingAddressSame === 'yes'
                ? data?.businessPostalCode
                : data?.mailingPostalCode,
          },

          primaryContactNo: data?.telephoneNumber ?? undefined,
          saffCompsition: this.getStaffComposition(data),
          tccExpiryDate: data?.tccExpiryDate ?? undefined,
          tccNumber: data?.tccNumber ?? undefined,
          trn: data?.businessTrn ?? undefined,
          workPermitIsInRelationTo:
            data?.workPermit === 'others'
              ? data?.workPermitOthers
              : data?.workPermit ?? undefined,
        },
        jobInfo: {
          JobId: data?.jobId ?? undefined,
          JobTitle: data?.jobTitle ?? undefined,
          jobDuties: data?.jobDuties ?? undefined,
          allowances: {
            car: data?.car ? parseInt(data?.car) : 0,
            entertainment: data?.entertainment
              ? parseInt(data?.entertainment)
              : 0,
            house: data?.house ? parseInt(data?.house) : 0,
            other: data?.allowanceOther ? parseInt(data?.allowanceOther) : 0,
          },
          currency: undefined,
          description: undefined,
          necessaryQualification: data?.qualifications ?? undefined,
          salaryOffered: data?.salaryOffered
            ? parseInt(data?.salaryOffered)
            : 0,
          registeredLMIS: data?.registeredLMIS === 'yes' ? true : false,
          workingHours: data?.workingHours ?? undefined,
          benefitsReceived: data?.benefitsReceived === 'yes' ? true : false,
          stepsForJaimacanTaken:
            data?.byAdvertisement === 'yes' ||
            data?.internalRecruitment === 'yes' ||
            data?.registeredLMIS === 'yes'
              ? true
              : false,
          stepsForJaimacan: {
            byAdvertisement: data?.byAdvertisement === 'yes' ? true : false,
            didJamaicanApply: data?.didJamaicanApply === 'yes' ? true : false,
            appliedCandidates: data?.appliedCandidates
              ? parseInt(data?.appliedCandidates)
              : 0,
            reasonNoneHired: data?.reasonNoneHired ?? undefined,
            noStepTaken:
              data?.byAdvertisement === 'no' &&
              data?.internalRecruitment === 'no' &&
              data?.registeredLMIS === 'no'
                ? data?.noStepTaken
                : undefined,
            // internalRecruitment: {
            //   selected: data?.internalRecruitment ? true : false,
            //   value: data?.internalRecruitment ?? undefined,
            // },
            internalRecruitment:
              data?.internalRecruitment === 'yes' ? true : false,
          },
        },
      },
    };

    console.log('__data__', _data);
    return _data;
  };

  private getStaffComposition = (data: any) => {
    let _staffComposition: any = [];
    for (let i = 0; i < 4; i++) {
      if (i === 0) {
        _staffComposition.push({
          citizenship: 'JAMAICAN',
          professional: data?.jamaicanProfessional
            ? parseInt(data?.jamaicanProfessional)
            : 0,
          elementaryOccupations: data?.jamaicanElementary
            ? parseInt(data?.jamaicanElementary)
            : 0,
          skilledWorkers: data?.jamaicanSkilledWorkers
            ? parseInt(data?.jamaicanSkilledWorkers)
            : 0,
          clerksOrServiceWorker: data?.jamaicanClerks
            ? parseInt(data?.jamaicanClerks)
            : 0,
          plantAndMachineOperators: data?.jamaicanPlant
            ? parseInt(data?.jamaicanPlant)
            : 0,
        });
      } else if (i === 1) {
        _staffComposition.push({
          citizenship: 'CARRICOM',
          professional: data?.carricomProfessional
            ? parseInt(data?.carricomProfessional)
            : 0,
          elementaryOccupations: data?.carricomElementary
            ? parseInt(data?.carricomElementary)
            : 0,
          skilledWorkers: data?.carricomSkilledWorkers
            ? parseInt(data?.carricomSkilledWorkers)
            : 0,
          clerksOrServiceWorker: data?.carricomClerks
            ? parseInt(data?.carricomClerks)
            : 0,
          plantAndMachineOperators: data?.carricomPlant
            ? parseInt(data?.carricomPlant)
            : 0,
        });
      } else if (i === 2) {
        _staffComposition.push({
          citizenship: 'COMMON_WEALTH',
          professional: data?.commonWealthProfessional
            ? parseInt(data?.commonWealthProfessional)
            : 0,
          elementaryOccupations: data?.commonWealthElementary
            ? parseInt(data?.commonWealthElementary)
            : 0,
          skilledWorkers: data?.commonWealthSkilledWorkers
            ? parseInt(data?.commonWealthSkilledWorkers)
            : 0,
          clerksOrServiceWorker: data?.commonWealthClerks
            ? parseInt(data?.commonWealthClerks)
            : 0,
          plantAndMachineOperators: data?.commonWealthPlant
            ? parseInt(data?.commonWealthPlant)
            : 0,
        });
      } else if (i === 3) {
        _staffComposition.push({
          citizenship: 'FOREGION',
          professional: data?.foreignProfessional
            ? parseInt(data?.foreignProfessional)
            : 0,
          elementaryOccupations: data?.foreignElementary
            ? parseInt(data?.foreignElementary)
            : 0,
          skilledWorkers: data?.foreignSkilledWorkers
            ? parseInt(data?.foreignSkilledWorkers)
            : 0,
          clerksOrServiceWorker: data?.foreignClerks
            ? parseInt(data?.foreignClerks)
            : 0,
          plantAndMachineOperators: data?.foreignPlant
            ? parseInt(data?.foreignPlant)
            : 0,
        });
      }
    }
    return _staffComposition;
  };

  // {
  //   citizenship: undefined,
  //   clerksOrServiceWorker: undefined,
  //   elementaryOccupations: undefined,
  //   plantAndMachineOperators: undefined,
  //   professional: undefined,
  //   skilledWorkers: undefined,
  //   //total: data?.totalStaff ? parseInt(data?.totalStaff) : 0,
  // },

  private getDocuments(data: any, type: string) {
    let _documents: any[] = [];
    console.log(`workPermitApp service getDocuments`, data);

    workPermitConfig?.availableDocuments &&
      Object.entries(workPermitConfig?.availableDocuments).forEach((ele) => {
        if (
          data[ele[0]] &&
          Array.isArray(data[ele[0]]) &&
          data[ele[0]].length > 0
        ) {
          let _docs: any[] = [];
          console.log(`workPermitApp service getDocuments #1`, data[ele[0]]);
          const ans = data[ele[0]];
          let addOn = {};

          ans &&
            Array.isArray(ans) &&
            ans.length > 0 &&
            ans.forEach((e) => {
              _docs.push({
                operation: e?.operation,
                ...addOn,
                name: e?.name,
                type: ele[1],
                src: e?.base64 ?? e?.src,
                fileType: e?.type,
              });
            });

          // if (data[`expiry${ele[0]}`]) {
          //   //@ts-ignore
          //   res = { ...res, expiry: data[`expiry${ele[0]}`] };
          // }
          console.log(
            `workPermitApp service getDocuments #2`,
            _documents,
            _docs
          );
          _documents = [..._documents, ..._docs];
        }
      });
    console.log('docss', _documents);
    return _documents;
  }

  private getDependentInfo(data: any) {
    let _dependentInfo: any[] = [];
    console.log(
      `workPermitApp service getDependentInfo`,
      data?.dependentInfo,
      data
    );
    data &&
      Array.isArray(data?.dependentInfo) &&
      data?.dependentInfo.length > 0 &&
      data?.dependentInfo.forEach((e: any) => {
        _dependentInfo.push({
          dependentType: e?.dependentType ?? undefined,
          name: e?.dependentName ?? undefined,
          age: e?.dependentAge ? parseInt(e?.dependentAge) : undefined,
          gender: e?.dependentSex ?? undefined,
          nationality: e?.dependentNationality ?? undefined,
          relationship: e?.dependentRelationship ?? undefined,
          passportNumber: e?.dependentPassport ?? undefined,
        });
      });
    return _dependentInfo;
  }

  private getWorkExperience(data: any) {
    let _workExperience: any[] = [];
    console.log(
      `workPermitApp service getWorkExperience`,
      data?.workExperience
    );
    data &&
      Array.isArray(data?.workExperience) &&
      data?.workExperience.length > 0 &&
      data?.workExperience.forEach((ele: any) => {
        _workExperience.push({
          from: ele?.wePeriodStart,
          to: ele?.wePeriodEnd,
          jobDuty: ele?.jobDutyType,
          nameOfOrganization: ele?.organizationName,
        });
      });
    return _workExperience;
  }

  private getQualification(data: any) {
    let _qualification: any[] = [];
    console.log(`workPermitApp service getQualification`, data);
    data &&
      Array.isArray(data) &&
      data.length > 0 &&
      data.forEach((ele: any) => {
        console.log(
          `workPermitApp service getQualification`,
          ele?.qualificationName
        );

        _qualification.push({
          degree: ele?.qualificationName,
          from: ele?.dateOfQualification,
        });
      });
    return _qualification;
  }
}
